module.exports = __webpack_public_path__ + "img/中国航空体育协会@3x.0cf02090.png";